import { Box } from "@repo/components/src/ui/box";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
} from "@repo/components/src/ui/form-control";
import { HStack } from "@repo/components/src/ui/hstack";
import { Pressable } from "@repo/components/src/ui/pressable";
import { AlertCircleIcon } from "lucide-react-native";
import { Controller, FieldValues } from "react-hook-form";
import { FormInputProps } from "@repo/components/src/forms/types";

import { COLOR_PALETTE } from "./tagFormSchema";

export default function ColorPicker<TFieldValues extends FieldValues>(
  props: Omit<FormInputProps<TFieldValues, string>, "placeholder">,
) {
  const { control, name, required, disabled, className, size } = props;
  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl
          isInvalid={!!error}
          isRequired={required}
          isDisabled={disabled}
          className={className}
          size={size}
        >
          <HStack space="xs" className="flex-wrap">
            {COLOR_PALETTE.map((c) => (
              <Pressable key={c.hex} onPress={() => onChange(c.hex)}>
                <Box
                  className="w-6 h-6 rounded-full items-center justify-center"
                  style={{
                    backgroundColor: c.hex,
                    borderWidth: value === c.hex ? 2 : 0,
                    borderColor: "#000",
                  }}
                />
              </Pressable>
            ))}
          </HStack>
          <FormControlError>
            <FormControlErrorIcon as={AlertCircleIcon} className="mr-1" />
            <FormControlErrorText>{error?.message}</FormControlErrorText>
          </FormControlError>
        </FormControl>
      )}
    />
  );
}
